export type LivePreviewRefreshInput = {
  showPreview: boolean;
  websiteChanged: boolean;
  hasDesignChanges: boolean;
  updatedFields?: Record<string, unknown> | null;
};

export function shouldRefreshLivePreview({
  showPreview,
  websiteChanged,
  hasDesignChanges,
  updatedFields,
}: LivePreviewRefreshInput): boolean {
  if (websiteChanged) return true;
  if (!showPreview) return false;

  const hasUpdatedFields =
    updatedFields != null && Object.keys(updatedFields).length > 0;

  return hasDesignChanges || hasUpdatedFields;
}
